import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { defaultLocale, getLocaleFromPath, locales } from '@/lib/locales'
import fr from './locales/fr.json'
import en from './locales/en.json'

const initialLocale = typeof window !== 'undefined'
  ? getLocaleFromPath(window.location.pathname)
  : defaultLocale

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    lng: initialLocale,
    fallbackLng: defaultLocale,
    supportedLngs: locales as unknown as string[],
    interpolation: { escapeValue: false },
    returnNull: false,
  })

export default i18n
